import api from "./Api";

class OrderingCatalogService {
  GetStores() {
    return api.get("/v1/OrderingCatalog/stores").then((response) => {
      return response.data;
    });
  }

  GetGroups() {
    return api.get("/v1/OrderingCatalog/groups").then((response) => {
      return response.data;
    });
  }

  GetProducts(storeId, params) {
    return api
      .get(`/v1/OrderingCatalog/stores/${storeId}/products`, { params })
      .then((response) => {
        return response.data;
      });
  }

  SaveProduct(storeId, productId, payload) {
    return api
      .put(
        `/v1/OrderingCatalog/stores/${storeId}/products/${productId}`,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }

  SetBulkPublication(storeId, payload) {
    return api
      .post(
        `/v1/OrderingCatalog/stores/${storeId}/products/bulk-publication`,
        payload
      )
      .then((response) => {
        return response.data;
      });
  }
}

export default new OrderingCatalogService();
